export function sanitizeText(input, { maxLength = 500 } = {}) {
  const str = String(input ?? '');
  // Retirer les caractères de contrôle sans regex de contrôle (évite no-control-regex)
  let withoutControl = '';
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    if ((code >= 32 && code !== 127) || code === 10 || code === 13 || code === 9) {
      withoutControl += str[i];
    }
  }
  const noTags = withoutControl.replace(/<[^>]*>/g, '');
  return noTags.slice(0, maxLength).trim();
}

export function sanitizeEmail(email, { maxLength = 254 } = {}) {
  const str = sanitizeText(email, { maxLength });
  return str.replace(/\s+/g, '');
}

export function sanitizeUrl(url, { maxLength = 2048 } = {}) {
  const str = sanitizeText(url, { maxLength });
  try {
    const u = new URL(str, window.location.origin);
    return u.href;
  } catch {
    return '';
  }
}



